import { FC, Fragment } from "react";
import { Divider, Stack, Typography } from "@mui/material";
import { InfrastructureArchitectureHierarchyItem } from "./InfrastructureArchitectureHierarchyItem";
import { useAppSelector } from "@/store/hooks";
import { infrastructureArchitectureHierarchySelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureHierarchySelector";

export const InfrastructureArchitectureHierarchy: FC = () => {
  const hierarchy = useAppSelector(infrastructureArchitectureHierarchySelector);
  const key = Object.keys(hierarchy ?? {}).at(0);

  if (!hierarchy || !key) {
    return null;
  }

  return (
    <Fragment>
      <Divider sx={{ py: 0.5 }} />

      <Typography variant="body2" fontWeight="medium">
        Infrastructure
      </Typography>

      <Stack overflow="auto">
        <InfrastructureArchitectureHierarchyItem
          hierarchyLevel={0}
          resourceName={key}
          resourceLabel="region"
          hierarchy={hierarchy[key ?? ""]}
        />
      </Stack>
    </Fragment>
  );
};
